import { useRef, useState } from 'react';
import { api, apiError } from '@/lib/pos-api';
import { useAuth } from '@/context/AuthContext';
import WriteButton from '@/components/WriteButton';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';

// Mount with key={contact.id}; editing never creates or replaces a contact.
export default function ContactEditDialog({ contact, onClose, onSaved }) {
  const { readOnly } = useAuth();
  const [name, setName] = useState(contact.name || '');
  const [phone, setPhone] = useState(contact.phone || '');
  const [busy, setBusy] = useState(false), [error, setError] = useState('');
  const flight = useRef(false);
  const save = async event => {
    event.preventDefault();
    if (flight.current || readOnly) return;
    if (!name.trim()) { setError('Nama pelanggan wajib diisi'); return; }
    flight.current = true; setBusy(true); setError('');
    try {
      const { data } = await api.put(`/customers/${contact.id}`, { name:name.trim(), phone:phone.trim() || null });
      onSaved(data); onClose();
    } catch (e) { setError(apiError(e)); }
    finally { flight.current = false; setBusy(false); }
  };
  return <Dialog open onOpenChange={value => { if (!value && !busy) onClose(); }}>
    <DialogContent data-testid="edit-customer-dialog" className="w-[calc(100%-2rem)] max-w-md max-h-[90dvh] overflow-y-auto bg-ui-card text-ui-text border-ui-line">
      <DialogHeader><DialogTitle>Edit Pelanggan</DialogTitle><DialogDescription>Revisi nama atau nomor HP pada pelanggan yang sama. Riwayat transaksi dan saldo piutang tidak berubah.</DialogDescription></DialogHeader>
      <form onSubmit={save} className="space-y-4">
        <div className="space-y-1"><Label htmlFor="edit-contact-name">Nama pelanggan</Label><Input id="edit-contact-name" data-testid="edit-contact-name" autoFocus required maxLength={300} disabled={busy} value={name} onChange={e => setName(e.target.value)} /></div>
        <div className="space-y-1"><Label htmlFor="edit-contact-phone">No. HP (opsional)</Label><Input id="edit-contact-phone" data-testid="edit-contact-phone" type="tel" maxLength={100} disabled={busy} value={phone} onChange={e => setPhone(e.target.value)} /></div>
        {error && <p role="alert" className="text-sm text-danger-readable">{error}</p>}
        <DialogFooter><Button type="button" variant="outline" disabled={busy} onClick={onClose}>Batal</Button><WriteButton type="submit" data-testid="save-contact-edit" disabled={busy}>{busy ? 'Menyimpan…' : 'Simpan revisi'}</WriteButton></DialogFooter>
      </form>
    </DialogContent>
  </Dialog>;
}
